import styled from 'styled-components'

import { Link } from 'react-router-dom'

import { theme } from '../../styles/theme'

export const Container = styled.div`
  width: 100%;
  height: 238px;

  margin-bottom: 24px;

  border-radius: ${theme.border.mediumRadius};

  div[role='menubar'] {
    display: none;
  }

  button[aria-label='Toggle fullscreen view'] {
    display: none;
  }

  button[aria-label='Drag Pegman onto the map to open Street View'] {
    display: none;
  }

  div[class='gmnoprint'] {
    display: none;
  }

  @media (min-width: 768px) {
    height: 400px;
  }
`

export const LinkToGoogleMaps = styled(Link)`
  color: ${theme.colors.system};
  font-size: ${theme.font.sizes.small};
  text-decoration: none;

  margin-top: 8px;

  display: flex;
  align-items: center;

  svg {
    width: 8px;
    height: 8px;

    margin-left: 4px;

    path {
      fill: ${theme.colors.system};
    }
  }

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.normal};
  }
`
